import React from 'react';
import './css/main.css';
import Background from './components/Background/Background';
import RouterConfig from './config/routes';

function App() {
  return (
    <main>
      <RouterConfig/>
      {/* <Background /> */}
    </main>
  );
}

export default App;
